import React, { memo } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import BackImage from "../../../../common/img/back_icon.svg";
const CompassSettingSaveConfirm = ({
  onClose,
  title,
  textButton1,
  onClickButton1,
  disabledButton1,
  textButton2,
  onClickButton2,
  disabledButton2,
  ...rest
}) => {
  return (
    // <Dialog
    //   aria-labelledby="max-width-dialog-title"
    //   fullWidth
    //   maxWidth="xs"
    //   onClose={onClose}
    //   {...rest}
    //   disableBackdropClick={true}
    // >
    //   <Fab onClick={onClose} size="small" className="white-text close-button">
    //     <ArrowBackIcon />
    //   </Fab>
    //   <DialogTitle disableTypography>
    //     <Typography variant="h5" className="dialog-title white-text text-center">
    //       {title}
    //     </Typography>
    //   </DialogTitle>
    //   <DialogContent className="confirm-content">
    //     <Button
    //       disabled={disabledButton1}
    //       onClick={onClickButton1}
    //       size="large"
    //       className="compass-setting-confirm-dialog-btn-option"
    //     >
    //       {textButton1}
    //     </Button>
    //     <Typography variant="h6" className="white-text text-center">
    //       or
    //     </Typography>
    //     <Typography variant="h6" className="white-text text-center">
    //       下の図面リストから、方位情報の反映対象図面を選択してください。
    //       複数選択可能
    //     </Typography>
    //     <Button
    //       disabled={disabledButton2}
    //       onClick={onClickButton2}
    //       size="large"
    //       className="compass-setting-confirm-dialog-btn-option"
    //     >
    //       {textButton2}
    //     </Button>
    //   </DialogContent>
    // </Dialog>

    <Grid className="compass-setting-confirm-dialog-container-save">

      <DialogTitle disableTypography>

        <Typography variant="h5" className="dialog-title white-text text-center">
          <img src={BackImage} onClick={onClose} className={"white-text close-button-compass"} />
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent className="confirm-content">
        <Button
          disabled={disabledButton1}
          onClick={onClickButton1}
          size="large"
          className="compass-setting-confirm-save-dialog-btn-option-1"
        >
          {textButton1}
        </Button>
        <Typography variant="h6" className="white-text text-center">
          Or
        </Typography>
        <Typography variant="h6" className="white-text text-center">
          下の図面リストから、方位情報の反映対
        </Typography>
        <Typography variant="h6" className="white-text text-center">
          象図面を選択してください
        </Typography>
        <Typography variant="h6" className="white-text text-center">
          ※複数選択可能
        </Typography>
        <Button
          disabled={disabledButton2}
          onClick={onClickButton2}
          size="large"
          className="compass-setting-confirm-dialog-btn-option"
        >
          {textButton2}
        </Button>
      </DialogContent>
    </Grid>
  );
};

CompassSettingSaveConfirm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  textButton1: PropTypes.string,
  textButton2: PropTypes.string
};

export default memo(CompassSettingSaveConfirm);
